
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TeamSection from './components/TeamSection';
import MissionSection from './components/MissionSection';
import ExperienceSection from './components/ExperienceSection';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <MissionSection />
        <TeamSection />
        <ExperienceSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
